@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.loading {
  display: flex;
  justify-content: space-between;
  align-items: center;

  [data-autopilot-system-redesign='on'] & {
    background: transparent;
  }

  .loadingContent {
    display: flex;
    align-items: center;
    gap: 5px;

    [data-autopilot-system-redesign='on'] & {
      background: linear-gradient(
        92deg,
        rgba(0, 0, 0, 0.8) 4.97%,
        rgba(163, 163, 163, 0.8) 23.86%,
        rgba(0, 0, 0, 0.8) 42.76%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 500% auto;
      animation: textShine 2s ease-in-out infinite alternate;
    }

    .loadingText {
      background: linear-gradient(90deg, #0099f7 0%, rgba(0, 153, 247, 0.4) 56.25%, #0099f7 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      [data-autopilot-system-redesign='on'] & {
        background: none;
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
  }
}

@keyframes textShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
